export default __webpack_public_path__ + "static/media/double-arrow.ed97ba0a.svg";